export const REPORT_IDS = {
  SERVICE_REQUESTS_SUMMARY: 'service-requests-summary',
  TARGET_TIMES_REPORT: 'target-times-report',
  PREVENTIVE_MAINTENANCE_TASKS_SUMMARY: 'preventive-maintenance-tasks-summary',
  SERVICE_REQUEST_RESPONSE_TIME_ALL: 'service-request-response-time-all',
  SERVICE_REQUEST_RESPONSE_TIME_AVERAGE:
    'service-request-response-time-average',
  SERVICE_REQUEST_ACCEPTANCE_TIME_ALL: 'service-request-acceptance-time-all',
  SERVICE_REQUEST_ACCEPTANCE_TIME_AVERAGE:
    'service-request-acceptance-time-average',
  SERVICE_REQUEST_COMPLETION_TIME_ALL: 'service-request-completion-time-all',
  SERVICE_REQUEST_COMPLETION_TIME_AVERAGE:
    'service-request-completion-time-average',
  PREVENTIVE_MAINTENANCE_TIME_EVALUATION_BY_TASK:
    'preventive-maintenance-time-evaluation-by-task',
  PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_PROPERTY:
    'preventive-maintenance-task-performance-by-property',
  PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_ASSIGNED_USER:
    'preventive-maintenance-task-performance-by-assigned-user',
  PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_ASSIGNED_TEAM:
    'preventive-maintenance-task-performance-by-assigned-team',
  SERVICE_REQUEST_TENANT_SURVEY_SUMMARY_ALL:
    'service-request-tenant-survey-summary-all',
  SERVICE_REQUEST_TENANT_SURVEY_SUMMARY_DETAILS:
    'service-request-tenant-survey-summary-details',
  PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_SCHEDULE:
    'preventive-maintenance-task-performance-by-schedule',
  BILLING_EXPORT_REPORT: 'billing-export-report',
  FIN_CHARGE: 'fin-charge',
  FIN_JOURNAL: 'fin-journal',
} as const;

export const REPORT_NAMES = {
  SERVICE_REQUESTS_SUMMARY: 'service-requests-summary',
  TARGET_TIMES_REPORT: 'target-times-report',
  PREVENTIVE_MAINTENANCE_TASKS_SUMMARY: 'preventive-maintenance-tasks-summary',
  SERVICE_REQUEST_RESPONSE_TIME: 'service-request-response-time',
  SERVICE_REQUEST_ACCEPTANCE_TIME: 'service-request-acceptance-time',
  SERVICE_REQUEST_COMPLETION_TIME: 'service-request-completion-time',
  SERVICE_REQUEST_TENANT_SURVEY_SUMMARY:
    'service-request-tenant-survey-summary',
  PREVENTIVE_MAINTENANCE_TIME_EVALUATION_BY_TASK:
    'preventive-maintenance-time-evaluation-by-task',
  PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_PROPERTY:
    'preventive-maintenance-task-performance-by-property',
  PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_ASSIGNED_USER:
    'preventive-maintenance-task-performance-by-assigned-user',
  PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_ASSIGNED_TEAM:
    'preventive-maintenance-task-performance-by-assigned-team',
  PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_SCHEDULE: 'preventive-maintenance-task-performance-by-schedule',
  BILLING_EXPORT_REPORT: 'billing-export-report',
  FIN_CHARGE: 'fin-charge',
  FIN_JOURNAL: 'fin-journal',
} as const;

export const REPORT_NAME_TO_IDS_MAP = {
  'service-requests-summary': [REPORT_IDS.SERVICE_REQUESTS_SUMMARY],
  'target-times-report': [REPORT_IDS.TARGET_TIMES_REPORT],
  'preventive-maintenance-tasks-summary': [
    REPORT_IDS.PREVENTIVE_MAINTENANCE_TASKS_SUMMARY,
  ],
  'service-request-response-time': [
    REPORT_IDS.SERVICE_REQUEST_RESPONSE_TIME_AVERAGE,
    REPORT_IDS.SERVICE_REQUEST_RESPONSE_TIME_ALL,
  ],
  'service-request-acceptance-time': [
    REPORT_IDS.SERVICE_REQUEST_ACCEPTANCE_TIME_AVERAGE,
    REPORT_IDS.SERVICE_REQUEST_ACCEPTANCE_TIME_ALL,
  ],
  'service-request-completion-time': [
    REPORT_IDS.SERVICE_REQUEST_COMPLETION_TIME_AVERAGE,
    REPORT_IDS.SERVICE_REQUEST_COMPLETION_TIME_ALL,
  ],
  'service-request-tenant-survey-summary': [
    REPORT_IDS.SERVICE_REQUEST_TENANT_SURVEY_SUMMARY_ALL,
    REPORT_IDS.SERVICE_REQUEST_TENANT_SURVEY_SUMMARY_DETAILS,
  ],
  'preventive-maintenance-time-evaluation-by-task': [
    REPORT_IDS.PREVENTIVE_MAINTENANCE_TIME_EVALUATION_BY_TASK,
  ],
  'preventive-maintenance-task-performance-by-property': [
    REPORT_IDS.PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_PROPERTY,
  ],
  'preventive-maintenance-task-performance-by-assigned-user': [
    REPORT_IDS.PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_ASSIGNED_USER,
  ],
  'preventive-maintenance-task-performance-by-assigned-team': [
    REPORT_IDS.PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_ASSIGNED_TEAM,
  ],
  'preventive-maintenance-task-performance-by-schedule': [
    REPORT_IDS.PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_SCHEDULE,
  ],
  'billing-export-report': [REPORT_IDS.BILLING_EXPORT_REPORT],
  'fin-charge': [REPORT_IDS.FIN_CHARGE],
  'fin-journal': [REPORT_IDS.FIN_JOURNAL],
} as const;

export type ReportName = keyof typeof REPORT_NAME_TO_IDS_MAP;

export function getReportIds(reportName: string): string[] {
  const reportIds = REPORT_NAME_TO_IDS_MAP[reportName as ReportName];

  return reportIds ? [...reportIds] : [];
}
